export const hasAccessToMerchant = (merchants, merchantId) => {
    if (!merchantId || !merchants) return null

    return merchants.some((m) => m.id == merchantId)
}
